export default function BottomCall() {
  return (
   <div className="bottom-call-btn">
        <div className="bottom-call-tooltip">
            <i className="fas fa-headset"></i>
            <span>Talk to Expert: 9155365156</span>
        </div>
        <a href="tel:9155365156" className="bottom-call-button">
            <i className="fas fa-phone"></i>
        </a>
    </div>
  );
}